import { Component, Input, inject } from "@angular/core"
import { MatDialog } from "@angular/material/dialog"
import { MatIcon } from "@angular/material/icon"
import { MatTooltip } from "@angular/material/tooltip"
import { ExpandDialogComponent } from "./expand-dialog.component"

@Component({
    selector: "valben-expand-modal",
    standalone: true,
    template: `
        <button
            type="button"
            class="valben-row-action"
            [attr.aria-label]="tooltip"
            [matTooltip]="tooltip"
            (click)="open()">
            <mat-icon>{{ icon }}</mat-icon>
        </button>`,
    imports: [MatIcon, MatTooltip],
})
export class ExpandModalComponent {
    @Input() data!: any
    @Input() icon: string = "sell"
    @Input() tooltip: string = "Detalji"
    @Input() emptyMessage: string = ""

    private readonly _dialog = inject(MatDialog)

    open(): void {
        this._dialog.open(ExpandDialogComponent, {
            data: { data: this.data, emptyMessage: this.emptyMessage },
            minWidth: "10vw",
            maxWidth: "20vw",
        })
    }
}
